
  (function() {
    class discountBox extends HTMLElement {
      constructor() {
        super();
        this.form = document.querySelector(".cart-page");
        this.drawerform = document.querySelector(".cart-drawer__footer");
        this.applyBtn = this.querySelector('[data-for="discount-apply-btn"]');
        this.discountInput = this.querySelector('[data-for="discount-input-box"]');
        this.messageBox = this.querySelector('[data-for="message"]');
        this.staticBoxes = this.querySelectorAll('.static-discount-box');
      }

     connectedCallback() {
   
        if (this.form) {
          this.applyBtn.addEventListener('click', (event) => this.handleSubmit(event));
        }
        if (this.drawerform) {
          this.applyBtn.addEventListener('click', (event) => this.handleSubmit(event));
        }
       this.staticBoxes.forEach((staticBox)=>{
         const staticBtn = staticBox.querySelector('button');
         const staticCode = staticBox.getAttribute('data-code');
        if (staticBtn && staticCode) {
          staticBtn.addEventListener('click', (event) =>
            this.applyDiscount(staticCode)
          )       }
       })
      }

      handleSubmit(event) {
        event.preventDefault();
        const code = this.discountInput.value.trim();
        if (!code) {
          this.showMessage('Please enter a discount code!', 'error');
          return;
        }
        this.hideMessage();
        this.applyDiscount(code);
      }

      async applyDiscount(code) {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
          try {
            const response = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ attributes: { discount_code: code } })
            });
            console.log("resp:", response);
            if (response.ok) {
              window.location.href = `/discount/${code}?redirect=${encodeURIComponent(window.location.pathname)}`;
              document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
            } else {
              throw new Error('Failed to apply discount');
            }
          } catch (error) {
            this.showMessage('Invalid code!', 'error');
          }
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        }

      checkExistingDiscount() {
        const urlParams = new URLSearchParams(window.location.search);
        const discount = urlParams.get('discount');
        
        if (discount) {
          this.showAppliedDiscount(discount);
        }

        if (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.discount) {
          this.showAppliedDiscount(window.Shopify.checkout.discount.code);
        }
      }

      showAppliedDiscount(code) {
        console.log(`Discount is already applied: ${code}`)
      }

      showMessage(text, type) {
         this.messageBox.textContent = text;
         this.messageBox.style.display = "block";
        this.messageBox.className = `active ${type}`;
      }

      hideMessage() {
         this.messageBox.style.display = "none";
      }
    }

    customElements.define('discount-box', discountBox);
  })();